import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hd-navbar-mobile',
  templateUrl: './navbar-mobile.component.html',
  styleUrls: ['./navbar-mobile.component.less']
})
export class NavbarMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
